// extracted by mini-css-extract-plugin
export default {"spinningYarnContainer":"Loading_spinningYarnContainer__IKZfX","bounce":"Loading_bounce__geXNL","spinningYarn":"Loading_spinningYarn__2TaKL","spin":"Loading_spin__iX0Ha"};